// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("@hotwired/turbo-rails");
require("@rails/activestorage").start();
require("channels");
require("controllers");
require("jquery");
require("easy-autocomplete");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

//= require jquery3
//= require popper
//= require bootstrap-sprockets
// TODO : Change bootstrap-sprockets to boostrap

//import * as Sentry from "@sentry/browser";
//import { Integrations } from "@sentry/tracing";

// Sentry.init({
//   dsn:
//     "https://2e7261af2fc04b34ac66bbd5a4a7f286@o76697.ingest.sentry.io/5616722",
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 1.0,
//   beforeSend(event) {
//     if (
//       event.exception.values[0].value ==
//       "Cannot read property '__sentry_instrumentation_handlers__' of undefined"
//     ) {
//       return null;
//     } else {
//       return event;
//     }
//   },
// });

window.initMap = function (...args) {
  const event = document.createEvent("Events");
  event.initEvent("google-maps-callback", true, true);
  event.args = args;
  window.dispatchEvent(event);
};
